<nav class="bottom-nav" aria-label="Mobile navigation">
  <a
    *ngFor="let item of navItems"
    [routerLink]="item.route"
    routerLinkActive="bottom-nav__item--active"
    class="bottom-nav__item"
  >
    <i class="pi {{ item.icon }}" aria-hidden="true"></i>
    <span class="bottom-nav__label">{{ item.label }}</span>
  </a>
</nav>
